import { render, staticRenderFns } from "./FileUploadForm.vue?vue&type=template&id=475e8cbd&scoped=true"
import script from "./FileUploadForm.vue?vue&type=script&lang=js"
export * from "./FileUploadForm.vue?vue&type=script&lang=js"
import style0 from "./FileUploadForm.vue?vue&type=style&index=0&id=475e8cbd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475e8cbd",
  null
  
)

export default component.exports